import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { DownloadLogsPage } from '@/features/files';

function LibraryDownloadsRoute(): ReactNode {
  return (
    <AuthGuard>
      <DownloadLogsPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/library_/downloads')({
  component: LibraryDownloadsRoute,
});
